<script src="../../extension/custom-button-files/DataTableArchivos.js"></script>

<lib-skeleton-form
*ngIf="!envioCompletado"
[hidden]="isLoading"
[numberOfRows]="14"
></lib-skeleton-form>

<!-- Enlace de formulario expuesto: quien llega por correo no tiene bandeja de tareas a la cual volver -->
<div class="enlace-cierre" *ngIf="envioCompletado">
  <div class="enlace-cierre-card" role="status">
    <h2>Formulario enviado</h2>
    <p>Los datos se guardaron correctamente. Ya puede cerrar esta ventana.</p>
  </div>
</div>

<div class="wrapper">

  <div class="loader">
    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">Cargando...</div>
    </div>
  </div>
</div>
<div id="form" [hidden]="!isLoading" [ngClass]="{'form-centered': isRedirectAccess}"></div>

<!-- Enlace de formulario expuesto: la sesión venció y se pide un OTP nuevo sin perder lo diligenciado -->
<app-otp-enlace
  *ngIf="sesionEnlace.solicitandoOtp$ | async"
  modo="modal"
  [clave]="sesionEnlace.clave"
  (validado)="sesionEnlace.completarSolicitud(true)"
  (cancelado)="sesionEnlace.completarSolicitud(false)"
></app-otp-enlace>

<div class="bottom-right-corner" *ngIf="!isRedirectAccess">
  <button class="ms-Button ms-Button--primary" (click)="abrirDatatableTareas()">
    <span class="ms-Button-label">Volver a Tareas</span>
  </button>
</div>



<!-- Modal -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-succes">
    <div class="ms-Dialog-title">Datos almacenados correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se han almacenado correctamente los datos.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>


<!-- Modal de progreso de carga de archivos por chunks -->
<div class="chunk-upload-overlay" *ngIf="chunkProgress.activo">
  <div class="chunk-upload-modal">
    <div class="chunk-upload-title">Subiendo archivos al servidor</div>
    <div class="chunk-upload-info">
      <p>
        <strong>Archivo {{ chunkProgress.archivoActual }} de {{ chunkProgress.totalArchivos }}</strong>
        &nbsp;·&nbsp;
        Parte {{ chunkProgress.parteActual }} de {{ chunkProgress.totalPartes }}
      </p>
      <p class="chunk-filename">{{ chunkProgress.nombreArchivo }}</p>
      <div class="chunk-progress-bar">
        <div class="chunk-progress-fill"
             [style.width.%]="chunkProgress.totalPartes > 0 ? (chunkProgress.parteActual / chunkProgress.totalPartes * 100) : 0">
        </div>
      </div>
      <p class="chunk-hint">No cierre esta pestaña ni cierre sesión hasta que la carga finalice.</p>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>